import { render, staticRenderFns } from "./Tuo.vue?vue&type=template&id=a266f8dc&scoped=true&"
import script from "./Tuo.vue?vue&type=script&lang=js&"
export * from "./Tuo.vue?vue&type=script&lang=js&"
import style0 from "./Tuo.vue?vue&type=style&index=0&id=a266f8dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a266f8dc",
  null
  
)

export default component.exports